<template>
  <div class="spl-user-list-filter">
    <form-input
      v-model="filterTerm"
      :required="false"
      :placeholder="'Filter by term'"
      class="spl-user-list-filter__item"
      style="grid-column: 1"
      @input="onFilterChange" />
    <customer-multiselect
      :selected-keys="customers"
      :limit-height="true"
      :placeholder="'Filter by customer'"
      class="spl-user-list-filter__item"
      style="grid-column: 2"
      @valuesSelected="onCustomersSelected" />
    <country-multiselect
      :selected-keys="countries"
      :limit-height="true"
      :placeholder="'Filter by country'"
      class="spl-user-list-filter__item"
      style="grid-column: 3"
      @valuesSelected="onCountriesSelected" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      filterTerm: '',
      customers: [],
      countries: []
    }
  },
  methods: {
    ...mapMutations('userManagment', ['setFilter']),
    onCustomersSelected (customers) {
      this.customers = customers
      this.onFilterChange()
    },

    onCountriesSelected (countries) {
      this.countries = countries
      this.onFilterChange()
    },

    onFilterChange () {
      // Sets the user filter in the vuex store
      this.setFilter({ term: this.filterTerm, customers: this.customers, countries: this.countries })
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  .spl-user-list-filter {
    background-color: $yellowButtonLabelHover;
    height: 66px;
    padding: 12px $mainPadding;
    width: 100%;
    display: grid;
    grid-gap: 2%;
    grid-template-columns: 30% 30% 30%;
    grid-template-rows: auto;
  }
</style>
